import * as React from 'react';
import {PVABadge} from "../reports";

interface BadgeLoadingIndicatorState {
    shuffledBadges: string[];
    currentShuffleIndex: number;
    isAnimating: boolean;
}

export class BadgeLoadingIndicator extends React.Component<{}, BadgeLoadingIndicatorState> {
    private intervalId?: number;
    private badges = ["relator", "strategist", "catalyst", "pragmatist", "maverick", "organizer", "analyzer", "evaluator"];

    constructor(props: {}) {
        super(props);
        this.state = {
            shuffledBadges: this.shuffleBadges(),
            currentShuffleIndex: 0,
            isAnimating: true,
        };
    }

    private shuffleBadges(): string[] {
        const shuffled = [...this.badges];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }

    componentDidMount() {
        this.intervalId = window.setInterval(() => {
            this.setState({
                ...this.state,
                isAnimating: false
            }, () => {
                setTimeout(() => {
                    const nextIndex = this.state.currentShuffleIndex + 1;
                    if (nextIndex >= this.state.shuffledBadges.length) {
                        this.setState({
                            ...this.state,
                            currentShuffleIndex: 0,
                            isAnimating: true
                        });
                    } else {
                        this.setState({
                            ...this.state,
                            currentShuffleIndex: nextIndex,
                            isAnimating: true
                        });
                    }
                }, 100);
            });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    render() {
        const currentBadge = this.state.shuffledBadges[this.state.currentShuffleIndex];

        return (
            <div className={`loading-badge-container ${this.state.isAnimating ? 'animating' : ''}`}>
                <PVABadge style={currentBadge} badge={currentBadge}></PVABadge>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loadingIndicator/BadgeLoadingIndicator.tsx